import { MicroHeader } from "features/shared/styles/typography/MicroHeader.styled";
import styled from "styled-components";

const PaxErrorMessage = styled(MicroHeader)`
  color: ${({ theme }) => theme.colors.base4};
  margin-top: 40px;
  white-space: pre-wrap;
  text-align: center;
`;

export default PaxErrorMessage;
